"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvroOptional = void 0;
function asOptional(avroType, value) {
    return value == null
        ? null
        : { [avroType]: value };
}
exports.AvroOptional = {
    boolean(value) {
        return asOptional('boolean', value);
    },
    int(value) {
        return asOptional('int', value);
    },
    long(value) {
        return asOptional('long', value);
    },
    float(value) {
        return asOptional('float', value);
    },
    double(value) {
        return asOptional('double', value);
    },
    bytes(value) {
        return asOptional('bytes', value);
    },
    string(value) {
        return asOptional('string', value);
    },
    array(value) {
        return asOptional('array', value);
    },
    map(value) {
        return asOptional('map', value);
    },
    record(typeName, value) {
        return asOptional(typeName, value);
    }
};
